"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postResetPassword = exports.postForgotPassword = exports.refreshTokens = exports.signIn = void 0;

var axios_1 = require("axios");

var common_1 = require("../common");

var signIn = function signIn(clientId, credentials) {
  return __awaiter(void 0, void 0, void 0, function () {
    var identityRoute, username, password, clientSecret, data, headers, params, response, _a, access_token, refresh_token, e_1;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 3,, 4]);

          identityRoute = common_1.configuration.identityRoot || 'https://identity.nimles.com';
          username = credentials.username, password = credentials.password, clientSecret = credentials.clientSecret;
          data = {
            username: username,
            password: password,
            scope: 'nimles offline_access',
            grant_type: 'password'
          };
          headers = {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
          };
          params = __assign(__assign({}, data), {
            client_id: clientId
          });

          if (clientSecret) {
            params['client_secret'] = clientSecret;
          }

          return [4
          /*yield*/
          , axios_1.default({
            method: 'POST',
            url: identityRoute + "/connect/token",
            headers: headers,
            data: new URLSearchParams(params).toString()
          })];

        case 1:
          response = _b.sent();
          return [4
          /*yield*/
          , response.data];

        case 2:
          _a = _b.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token;
          return [2
          /*return*/
          , {
            accessToken: access_token,
            refreshToken: refresh_token
          }];

        case 3:
          e_1 = _b.sent();
          console.error(e_1);
          throw e_1;

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
};

exports.signIn = signIn;

var refreshTokens = function refreshTokens(clientId, refreshToken) {
  return __awaiter(void 0, void 0, void 0, function () {
    var identityRoute, data, headers, response, json, access_token, refresh_token, error, e_2;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 3,, 4]);

          identityRoute = common_1.configuration.identityRoot || 'https://identity.nimles.com';
          data = {
            refresh_token: refreshToken,
            grant_type: 'refresh_token',
            client_id: clientId
          };
          headers = {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
          };
          return [4
          /*yield*/
          , axios_1.default({
            method: 'POST',
            url: identityRoute + "/connect/token",
            headers: headers,
            data: new URLSearchParams(data).toString()
          })];

        case 1:
          response = _a.sent();
          return [4
          /*yield*/
          , response.data];

        case 2:
          json = _a.sent();
          access_token = json.access_token, refresh_token = json.refresh_token, error = json.error;

          if (error) {
            throw new Error(error);
          }

          return [2
          /*return*/
          , {
            accessToken: access_token,
            refreshToken: refresh_token
          }];

        case 3:
          e_2 = _a.sent();
          console.error(e_2);
          throw e_2;

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
};

exports.refreshTokens = refreshTokens;

var postForgotPassword = function postForgotPassword(tenantId, username) {
  return __awaiter(void 0, void 0, void 0, function () {
    var apiRoute, data, headers, response, e_3;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          apiRoute = (common_1.configuration.apiRoot || 'https://api.nimles.com/') + 'identity/authorized';
          data = {
            username: username,
            resetPasswordUrl: common_1.configuration.urls.resetPassword || 'https://identity.nimles.com/resetpassword?tenant=' + tenantId
          };
          headers = {
            Accept: 'application/json',
            Tenant: tenantId
          };
          return [4
          /*yield*/
          , axios_1.default({
            method: 'POST',
            url: apiRoute + "/user/forgotpassword",
            headers: headers,
            data: data
          })];

        case 1:
          response = _a.sent();
          return [2
          /*return*/
          , {}];

        case 2:
          e_3 = _a.sent();
          console.error(e_3);
          throw e_3;

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
};

exports.postForgotPassword = postForgotPassword;

var postResetPassword = function postResetPassword(tenantId, password, code) {
  return __awaiter(void 0, void 0, void 0, function () {
    var apiRoute, data, headers, response, e_4;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          apiRoute = (common_1.configuration.apiRoot || 'https://api.nimles.com/') + 'identity/authorized';
          data = {
            password: password,
            newPasswordCode: code
          };
          headers = {
            Accept: 'application/json',
            Tenant: tenantId
          };
          return [4
          /*yield*/
          , axios_1.default({
            method: 'POST',
            url: apiRoute + "/user/resetpassword",
            headers: headers,
            data: data
          })];

        case 1:
          response = _a.sent();
          return [2
          /*return*/
          , {}];

        case 2:
          e_4 = _a.sent();
          console.error(e_4);
          throw e_4;

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
};

exports.postResetPassword = postResetPassword;